import {AssistantIcon} from "@/components/assistant/AssistantIcon.tsx";
import {CreateWithAssistantButton} from "@/components/assistant/CreateWithAssistantButton.tsx";
import {ManualCreateButton} from "@/components/assistant/ManualCreateButton.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {TableEmptyStateCta} from "@/components/table/subComponents/TableEmptyStateCta/TableEmptyStateCta.tsx";
import {ANALYZER} from "@/lib/featureFlags.ts";
import {AnalyzerSource} from "@/lib/queries/analyzerRuns.ts";

import styles from "./AssistantEmptyStateCta.module.scss";

const ASSISTANT_DESCRIPTION =
  "Point our Assistant at a URL and it will map your site's infrastructure and propose the right monitoring " +
  "in one step — or create a Check manually.";

interface AssistantEmptyStateCtaProps {
  title: string;
  source: AnalyzerSource;
  assistantTitle?: string;
  assistantDescriptionIntro?: string;
}

export const AssistantEmptyStateCta = ({
  title,
  source,
  assistantTitle,
  assistantDescriptionIntro,
}: AssistantEmptyStateCtaProps) => {
  const {user, userHasFeature} = useCurrentUserContext();
  const assistantEnabled = userHasFeature(ANALYZER);
  const hasWriteAccess = !!user?.has_write_access;

  if (!assistantEnabled || !hasWriteAccess) {
    return <TableEmptyStateCta title={title} cta={<ManualCreateButton />} />;
  }

  return (
    <TableEmptyStateCta
      header={<AssistantIcon />}
      title={assistantTitle || title}
      description={
        <span className={styles.description}>
          {assistantDescriptionIntro && `${assistantDescriptionIntro} `}
          {ASSISTANT_DESCRIPTION}
        </span>
      }
      cta={
        <div className="d-flex align-items-center gap-2 mt-2">
          <CreateWithAssistantButton source={source} />
          <ManualCreateButton />
        </div>
      }
    />
  );
};
